import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-a.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-a.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationDetailsAConstants } from "./view-application-details-a.constants";
import { CreateApplicationDetailsAConstants } from "../../../../create-application/modules/a/create-application-details-a/create-application-details-a.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { DatePipe } from "@angular/common";
import { AlertType } from "../../../../shared/models/alert";
import { take } from "rxjs/operators";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
let ViewApplicationDetailsAComponent = class ViewApplicationDetailsAComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    datePipe;
    changeDetectorRef;
    recipientService;
    routerParamsService;
    detailsForm;
    validationMessages = ViewApplicationDetailsAConstants.VALIDATION_MESSAGES;
    applicationDetailsFormGroupName = ViewApplicationDetailsAConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    // FormControls
    descriptionFormControlName = ViewApplicationDetailsAConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsAConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    displayStartDateControlName = ViewApplicationDetailsAConstants.DISPLAY_START_DATE_FORM_CONTROL_NAME;
    displayEndDateControlName = ViewApplicationDetailsAConstants.DISPLAY_END_DATE_FORM_CONTROL_NAME;
    displayRemovalDateControlName = ViewApplicationDetailsAConstants.DISPLAY_REMOVAL_DATE_FORM_CONTROL_NAME;
    numberOfPostersControlName = ViewApplicationDetailsAConstants.NUMBER_OF_POSTERS_FORM_CONTROL_NAME;
    nameOfBusinessControlName = ViewApplicationDetailsAConstants.NAME_OF_BUSINESS_FORM_CONTROL_NAME;
    notifySignageRemovalPeriodControlName = ViewApplicationDetailsAConstants.NOTIFY_SIGNAGE_REMOVAL_PERIOD_FORM_CONTROL_NAME;
    positionOfTheDisplayControlName = ViewApplicationDetailsAConstants.POSITION_OF_DISPLAY_FORM_CONTROL_NAME;
    heightControlName = ViewApplicationDetailsAConstants.HEIGHT_FORM_CONTROL_NAME;
    widthControlName = ViewApplicationDetailsAConstants.WIDTH_FORM_CONTROL_NAME;
    depthControlName = ViewApplicationDetailsAConstants.DEPTH_FORM_CONTROL_NAME;
    materialControlName = ViewApplicationDetailsAConstants.MATERIAL_FORM_CONTROL_NAME;
    coloursControlName = ViewApplicationDetailsAConstants.COLOURS_FORM_CONTROL_NAME;
    frontalAreaControlName = ViewApplicationDetailsAConstants.FRONTAL_AREA_FORM_CONTROL_NAME;
    totalAreaControlName = ViewApplicationDetailsAConstants.TOTAL_AREA_FORM_CONTROL_NAME;
    signTypeControlName = ViewApplicationDetailsAConstants.SIGN_TYPE_FORM_CONTROL_NAME;
    weightControlName = ViewApplicationDetailsAConstants.WEIGHT_FORM_CONTROL_NAME;
    wattageControlName = ViewApplicationDetailsAConstants.WATTAGE_FORM_CONTROL_NAME;
    signContractorControlName = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_NAME_FORM_CONTROL_NAME;
    signContractorAddressControlName = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_ADDRESS_FORM_CONTROL_NAME;
    signContractorTelephoneControlName = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_TELEPHONE_FORM_CONTROL_NAME;
    forSaleControlName = ViewApplicationDetailsAConstants.FOR_SALE_FORM_CONTROL_NAME;
    onShowControlName = ViewApplicationDetailsAConstants.ON_SHOW_FORM_CONTROL_NAME;
    toLetControlName = ViewApplicationDetailsAConstants.TO_LET_FORM_CONTROL_NAME;
    soldControlName = ViewApplicationDetailsAConstants.SOLD_FORM_CONTROL_NAME;
    OtherControlName = ViewApplicationDetailsAConstants.OTHER_FORM_CONTROL_NAME;
    constructionBoardSignControlName = ViewApplicationDetailsAConstants.CONSTRUCTION_BOARD_SIGN_FORM_CONTROL_NAME;
    groundSignControlName = ViewApplicationDetailsAConstants.GROUND_SIGN_FORM_CONTROL_NAME;
    flagControlName = ViewApplicationDetailsAConstants.FLAG_FORM_CONTROL_NAME;
    sandwichBoardControlName = ViewApplicationDetailsAConstants.SANDWICH_BOARD_FORM_CONTROL_NAME;
    pylonControlName = ViewApplicationDetailsAConstants.PYLON_FORM_CONTROL_NAME;
    wallSignControlName = ViewApplicationDetailsAConstants.WALL_SIGN_FORM_CONTROL_NAME;
    billBoardControlName = ViewApplicationDetailsAConstants.BILLBOARD_FORM_CONTROL_NAME;
    buildingAttachmentControlName = ViewApplicationDetailsAConstants.BUILDING_ATTACHMENT_FORM_CONTROL_NAME;
    projectingWallControlName = ViewApplicationDetailsAConstants.PROJECTING_WALL_SIGN_FORM_CONTROL_NAME;
    wallPaintedControlName = ViewApplicationDetailsAConstants.WALL_PAINTED_FORM_CONTROL_NAME;
    roofSignControlName = ViewApplicationDetailsAConstants.ROOF_SIGN_FORM_CONTROL_NAME;
    skySignControlName = ViewApplicationDetailsAConstants.SKY_SIGN_FORM_CONTROL_NAME;
    verandaControlName = ViewApplicationDetailsAConstants.VERANDA_FORM_CONTROL_NAME;
    aerialSignControlName = ViewApplicationDetailsAConstants.AERIAL_SIGN_FORM_CONTROL_NAME;
    windowSignControlName = ViewApplicationDetailsAConstants.WINDOW_SIGN_FORM_CONTROL_NAME;
    schoolSignControlName = ViewApplicationDetailsAConstants.SCHOOL_SIGN_FORM_CONTROL_NAME;
    combinationSignControlName = ViewApplicationDetailsAConstants.COMBINATION_SIGN_FORM_CONTROL_NAME;
    underAwningSignControlName = ViewApplicationDetailsAConstants.UNDER_AWNING_SIGN_FORM_CONTROL_NAME;
    flagSignControlName = ViewApplicationDetailsAConstants.FLAG_SIGN_FORM_CONTROL_NAME;
    canopyControlName = ViewApplicationDetailsAConstants.CANOPY_FORM_CONTROL_NAME;
    balconyControlName = ViewApplicationDetailsAConstants.BALCONY_FORM_CONTROL_NAME;
    electronicSignControlName = ViewApplicationDetailsAConstants.ELECTRONIC_SIGN_FORM_CONTROL_NAME;
    developmentBoardControlName = ViewApplicationDetailsAConstants.DEVELOPMENT_BOARD_FORM_CONTROL_NAME;
    otherFiveYearControlName = ViewApplicationDetailsAConstants.OTHER_FIVE_YEAR_FORM_CONTROL_NAME;
    nonIlluminatedBillboardControlName = ViewApplicationDetailsAConstants.NON_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    digitalBillboardControlName = ViewApplicationDetailsAConstants.DIGITAL_BILLBOARD_FORM_CONTROL_NAME;
    nonIlluminatedGantryControlName = ViewApplicationDetailsAConstants.NON_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    digitalGantryControlName = ViewApplicationDetailsAConstants.DIGITAL_GANTRY_FORM_CONTROL_NAME;
    internallyIlluminatedBillboardControlName = ViewApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    internallyIlluminatedGantryControlName = ViewApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    municipalConsumerAccountNumberFormControlName = ViewApplicationDetailsAConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_CONTROL_NAME;
    personResponsibleFormControlName = ViewApplicationDetailsAConstants.PERSON_RESPONSIBLE_CONTROL_NAME;
    // Labels
    descriptionLabel = ViewApplicationDetailsAConstants.DESCRIPTION_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = ViewApplicationDetailsAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    typeLabel = ViewApplicationDetailsAConstants.APPLICATION_TYPE_LABEL;
    displayStartDateLabel = ViewApplicationDetailsAConstants.DISPLAY_START_DATE_LABEL;
    displayEndDateLabel = ViewApplicationDetailsAConstants.DISPLAY_END_DATE_LABEL;
    displayRemovalDateLabel = ViewApplicationDetailsAConstants.DISPLAY_REMOVAL_DATE_LABEL;
    numberOfPostersLabel = ViewApplicationDetailsAConstants.NUMBER_OF_POSTERS_LABEL;
    nameOfBusinessLabel = ViewApplicationDetailsAConstants.NAME_OF_BUSINESS_LABEL;
    notifySignageRemovalPeriodLabel = ViewApplicationDetailsAConstants.NOTIFY_SIGNAGE_REMOVAL_LABEL;
    positionOfTheDisplayLabel = ViewApplicationDetailsAConstants.POSITION_OF_THE_DISPLAY_LABEL;
    heightLabel = ViewApplicationDetailsAConstants.HEIGHT_LABEL;
    widthLabel = ViewApplicationDetailsAConstants.WIDTH_LABEL;
    depthLabel = ViewApplicationDetailsAConstants.DEPTH_LABEL;
    materialLabel = ViewApplicationDetailsAConstants.MATERIAL_LABEL;
    coloursLabel = ViewApplicationDetailsAConstants.COLOURS_LABEL;
    frontalAreaLabel = ViewApplicationDetailsAConstants.FRONTAL_AREA_LABEL;
    totalAreaLabel = ViewApplicationDetailsAConstants.TOTAL_AREA_LABEL;
    signTypeLabel = ViewApplicationDetailsAConstants.SIGN_TYPE_LABEL;
    weightLabel = ViewApplicationDetailsAConstants.WEIGHT_LABEL;
    wattageLabel = ViewApplicationDetailsAConstants.WATTAGE_LABEL;
    signContractorLabel = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_LABEL;
    signContractorAddressLabel = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_ADDRESS_LABEL;
    signContractorTelephoneLabel = ViewApplicationDetailsAConstants.SIGN_CONTRACTOR_TELEPHONE_LABEL;
    forSaleAddressLabel = ViewApplicationDetailsAConstants.FOR_SALE_LABEL;
    // 1 year permanent
    onShowLabel = ViewApplicationDetailsAConstants.ON_SHOW_LABEL;
    toLetLabel = ViewApplicationDetailsAConstants.TO_LET_LABEL;
    soldLabel = ViewApplicationDetailsAConstants.SOLD_LABEL;
    constructionBoardSignLabel = ViewApplicationDetailsAConstants.CONSTRUCTION_BOARD_SIGN_LABEL;
    otherLabel = ViewApplicationDetailsAConstants.OTHER_LABEL;
    // 5 year permanent
    groundSignLabel = ViewApplicationDetailsAConstants.GROUND_SIGN_FORM_LABEL;
    flagLabel = ViewApplicationDetailsAConstants.FLAG_FORM_LABEL;
    sandwichBoardLabel = ViewApplicationDetailsAConstants.SANDWICH_BOARD_FORM_LABEL;
    pylonLabel = ViewApplicationDetailsAConstants.PYLON_FORM_LABEL;
    wallSignLabel = ViewApplicationDetailsAConstants.WALL_SIGN_FORM_LABEL;
    buildingAttachmentLabel = ViewApplicationDetailsAConstants.BUILDING_ATTACHMENT_LABEL;
    projectingWallLabel = ViewApplicationDetailsAConstants.PROJECTING_WALL_SIGN_LABEL;
    wallPaintedLabel = ViewApplicationDetailsAConstants.WALL_PAINTED_LABEL;
    roofSignLabel = ViewApplicationDetailsAConstants.ROOF_SIGN_LABEL;
    skySignLabel = ViewApplicationDetailsAConstants.SKY_SIGN_LABEL;
    verandaLabel = ViewApplicationDetailsAConstants.VERANDA_LABEL;
    aerialSignLabel = ViewApplicationDetailsAConstants.AERIAL_SIGN_LABEL;
    windowSignLabel = ViewApplicationDetailsAConstants.WINDOW_SIGN_LABEL;
    schoolSignLabel = ViewApplicationDetailsAConstants.SCHOOL_SIGN_LABEL;
    combinationSignLabel = ViewApplicationDetailsAConstants.COMBINATION_SIGN_LABEL;
    underAwningSignLabel = ViewApplicationDetailsAConstants.UNDER_AWNING_SIGN_LABEL;
    flagSignLabel = ViewApplicationDetailsAConstants.FLAG_SIGN_LABEL;
    canopyLabel = ViewApplicationDetailsAConstants.CANOPY_LABEL;
    balconyLabel = ViewApplicationDetailsAConstants.BALCONY_LABEL;
    electronicSignLabel = ViewApplicationDetailsAConstants.ELECTRONIC_SIGN_LABEL;
    developmentBoardLabel = ViewApplicationDetailsAConstants.DEVELOPMENT_BOARD_LABEL;
    otherFiveYearLabel = ViewApplicationDetailsAConstants.OTHER_FIVE_YEAR_LABEL;
    nonIlluminatedBillboardLabel = ViewApplicationDetailsAConstants.NON_ILLUMINATED_BILLBOARD_LABEL;
    digitalBillboardLabel = ViewApplicationDetailsAConstants.DIGITAL_BILLBOARD_LABEL;
    nonIlluminatedGantryLabel = ViewApplicationDetailsAConstants.NON_ILLUMINATED_GANTRY_LABEL;
    digitalGantryLabel = ViewApplicationDetailsAConstants.DIGITAL_GANTRY_LABEL;
    internallyIlluminatedBillboardLabel = ViewApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LABEL;
    internallyIlluminatedGantryLabel = ViewApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_GANTRY_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    municipalConsumerAccountNumberLabel = ViewApplicationDetailsAConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_LABEL;
    personResponsibleLabel = ViewApplicationDetailsAConstants.PERSON_RESPONSIBLE_CONTROL_LABEL;
    // Lookups
    signTypeLookups = [];
    removalPeriodLookups = LookupConstants.REMOVAL_PERIOD_LOOKUPS_A;
    nonIlluminatedBillboardLookups = LookupConstants.NON_ILLUMINATED_BILLBOARD_A;
    nonIlluminatedGantryLookups = LookupConstants.NON_ILLUMINATED_GANTRY_A;
    internallyIlluminatedBillboardLookups = LookupConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A;
    digitalGantryLookups = LookupConstants.DIGITAL_GANTRY_A;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    showTemporaryApplicationFields = false;
    showPermanentApplicationFields = false;
    show5YearPermanentApplicationOptionalFields = false;
    show1YearPermanentApplicationOptionalFields = false;
    // person responsible recipient
    personResponsibleDisableAdd = true;
    personResponsibleDisableEditing = false;
    personResponsibleDisableFilterBy = true;
    personResponsibleIsInternal = false;
    personResponsibleGroups = [];
    personResponsibleShowFields = true;
    temporaryApplicationType = [];
    permanentApplicationType = [];
    getLookupsObservableSubscription;
    selectedApplicationIASubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, datePipe, changeDetectorRef, recipientService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.datePipe = datePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.recipientService = recipientService;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
        try {
            this.personResponsibleGroups = stepMeta.personResponsibleGroup;
            this.changeDetectorRef.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsAConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "signtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.signTypeLookups.push(lookUpContent);
            }
        });
        this.subscribeToSelectedApplication();
        this.changeDetectorRef.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationIASubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
                this.detailsForm.get(this.descriptionFormControlName).disable();
                application.isAdvetisingPermanentOrTemporary === "permanent" ? this.configureFormsForPermanentApplication(application) : this.configureFormsForTemporaryApplication(application);
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    configureFormsForPermanentApplication(application) {
        this.setMainPermanentFields(application);
        this.getPersonResponsibleByApplicantId(application.personResponsibleId);
        if (application.type.toLowerCase().includes("1 year")) {
            this.show1YearPermanentApplicationOptionalFields = true;
            this.show5YearPermanentApplicationOptionalFields = false;
            this.set1yearPermanentApplicationFields(application);
        }
        if (application.type.toLowerCase().includes("5 year")) {
            this.show5YearPermanentApplicationOptionalFields = true;
            this.show1YearPermanentApplicationOptionalFields = false;
            this.set5yearPermanentApplicationFields(application);
        }
        this.showTemporaryApplicationFields = false;
    }
    setMainPermanentFields(application) {
        this.showPermanentApplicationFields = true;
        this.showTemporaryApplicationFields = false;
        this.detailsForm.get(this.nameOfBusinessControlName).setValue(application.nameOfBusiness);
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).setValue(application.notifySignageRemovalPeriod);
        this.detailsForm.get(this.positionOfTheDisplayControlName).setValue(application.positionOfDisplay);
        this.detailsForm.get(this.heightControlName).setValue(application.dimensionsH);
        this.detailsForm.get(this.widthControlName).setValue(application.dimensionsW);
        this.detailsForm.get(this.depthControlName).setValue(application.dimensionsD);
        this.detailsForm.get(this.materialControlName).setValue(application.material);
        this.detailsForm.get(this.coloursControlName).setValue(application.colours);
        this.detailsForm.get(this.frontalAreaControlName).setValue(application.frontalArea);
        this.detailsForm.get(this.totalAreaControlName).setValue(application.totalArea);
        this.detailsForm.get(this.signTypeControlName).setValue(application.signType);
        this.detailsForm.get(this.weightControlName).setValue(application.weight);
        this.detailsForm.get(this.wattageControlName).setValue(application.wattage);
        this.detailsForm.get(this.signContractorTelephoneControlName).setValue(application.contractorTelephone);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).setValue(application.municipalConsumerAccountNumber);
        this.detailsForm.get(this.nameOfBusinessControlName).disable();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).disable();
        this.detailsForm.get(this.positionOfTheDisplayControlName).disable();
        this.detailsForm.get(this.heightControlName).disable();
        this.detailsForm.get(this.widthControlName).disable();
        this.detailsForm.get(this.depthControlName).disable();
        this.detailsForm.get(this.materialControlName).disable();
        this.detailsForm.get(this.coloursControlName).disable();
        this.detailsForm.get(this.frontalAreaControlName).disable();
        this.detailsForm.get(this.totalAreaControlName).disable();
        this.detailsForm.get(this.signTypeControlName).disable();
        this.detailsForm.get(this.weightControlName).disable();
        this.detailsForm.get(this.wattageControlName).disable();
        this.detailsForm.get(this.signContractorTelephoneControlName).disable();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    set1yearPermanentApplicationFields(application) {
        this.show1YearPermanentApplicationOptionalFields = true;
        this.show5YearPermanentApplicationOptionalFields = false;
        this.detailsForm.get(this.forSaleControlName).setValue(application.forSale);
        this.detailsForm.get(this.onShowControlName).setValue(application.onShow);
        this.detailsForm.get(this.toLetControlName).setValue(application.toLet);
        this.detailsForm.get(this.soldControlName).setValue(application.sold);
        this.detailsForm.get(this.constructionBoardSignControlName).setValue(application.constructionBoardSign);
        this.detailsForm.get(this.OtherControlName).setValue(application.otherOneYear);
        this.detailsForm.get(this.forSaleControlName).disable();
        this.detailsForm.get(this.onShowControlName).disable();
        this.detailsForm.get(this.toLetControlName).disable();
        this.detailsForm.get(this.soldControlName).disable();
        this.detailsForm.get(this.constructionBoardSignControlName).disable();
        this.detailsForm.get(this.OtherControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    set5yearPermanentApplicationFields(application) {
        this.detailsForm.get(this.groundSignControlName).setValue(application.groundSign);
        this.detailsForm.get(this.flagControlName).setValue(application.flag);
        this.detailsForm.get(this.sandwichBoardControlName).setValue(application.sandwichBoard);
        this.detailsForm.get(this.pylonControlName).setValue(application.pylon);
        this.detailsForm.get(this.wallSignControlName).setValue(application.wallSign);
        this.detailsForm.get(this.billBoardControlName).setValue(application.billboard);
        this.detailsForm.get(this.groundSignControlName).disable();
        this.detailsForm.get(this.flagControlName).disable();
        this.detailsForm.get(this.sandwichBoardControlName).disable();
        this.detailsForm.get(this.pylonControlName).disable();
        this.detailsForm.get(this.wallSignControlName).disable();
        this.detailsForm.get(this.billBoardControlName).disable();
        this.detailsForm.get(this.buildingAttachmentControlName).setValue(application.buildingAttachment);
        this.detailsForm.get(this.projectingWallControlName).setValue(application.projectingWallSign);
        this.detailsForm.get(this.wallPaintedControlName).setValue(application.wallPainted);
        this.detailsForm.get(this.roofSignControlName).setValue(application.roofSign);
        this.detailsForm.get(this.skySignControlName).setValue(application.skySign);
        this.detailsForm.get(this.buildingAttachmentControlName).disable();
        this.detailsForm.get(this.projectingWallControlName).disable();
        this.detailsForm.get(this.wallPaintedControlName).disable();
        this.detailsForm.get(this.roofSignControlName).disable();
        this.detailsForm.get(this.skySignControlName).disable();
        this.detailsForm.get(this.verandaControlName).setValue(application.veranda);
        this.detailsForm.get(this.aerialSignControlName).setValue(application.aerialSign);
        this.detailsForm.get(this.windowSignControlName).setValue(application.windowSign);
        this.detailsForm.get(this.schoolSignControlName).setValue(application.schoolSign);
        this.detailsForm.get(this.combinationSignControlName).setValue(application.combinationSign);
        this.detailsForm.get(this.verandaControlName).disable();
        this.detailsForm.get(this.aerialSignControlName).disable();
        this.detailsForm.get(this.windowSignControlName).disable();
        this.detailsForm.get(this.schoolSignControlName).disable();
        this.detailsForm.get(this.combinationSignControlName).disable();
        this.detailsForm.get(this.underAwningSignControlName).setValue(application.underAwningSign);
        this.detailsForm.get(this.flagSignControlName).setValue(application.flagSign);
        this.detailsForm.get(this.canopyControlName).setValue(application.canopy);
        this.detailsForm.get(this.balconyControlName).setValue(application.balcony);
        this.detailsForm.get(this.electronicSignControlName).setValue(application.electronicSign);
        this.detailsForm.get(this.developmentBoardControlName).setValue(application.developmentBoard);
        this.detailsForm.get(this.underAwningSignControlName).disable();
        this.detailsForm.get(this.flagSignControlName).disable();
        this.detailsForm.get(this.canopyControlName).disable();
        this.detailsForm.get(this.balconyControlName).disable();
        this.detailsForm.get(this.electronicSignControlName).disable();
        this.detailsForm.get(this.developmentBoardControlName).disable();
        this.detailsForm.get(this.otherFiveYearControlName).setValue(application.otherFiveYear);
        this.detailsForm.get(this.otherFiveYearControlName).disable();
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).setValue(application.nonIlluminatedBillboard);
        this.detailsForm.get(this.digitalBillboardControlName).setValue(application.digitalBillboard);
        this.detailsForm.get(this.nonIlluminatedGantryControlName).setValue(application.nonIlluminatedGantry);
        this.detailsForm.get(this.digitalGantryControlName).setValue(application.digitalGantry);
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).setValue(application.internallyIlluminatedBillboard);
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).setValue(application.internallyIlluminatedGantry);
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).disable();
        this.detailsForm.get(this.digitalBillboardControlName).disable();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).disable();
        this.detailsForm.get(this.digitalGantryControlName).disable();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).disable();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    configureFormsForTemporaryApplication(application) {
        this.setTemporaryAdvertisementFields(application);
        this.showPermanentApplicationFields = false;
    }
    setTemporaryAdvertisementFields(application) {
        this.showTemporaryApplicationFields = true;
        this.showPermanentApplicationFields = false;
        this.detailsForm.get(this.displayStartDateControlName).setValue(this.datePipe.transform(application.displayStartDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.displayEndDateControlName).setValue(this.datePipe.transform(application.displayEndDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.displayRemovalDateControlName).setValue(this.datePipe.transform(application.displayRemovalDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.numberOfPostersControlName).setValue(application.numberOfPosters);
        this.detailsForm.get(this.displayStartDateControlName).disable();
        this.detailsForm.get(this.displayEndDateControlName).disable();
        this.detailsForm.get(this.displayRemovalDateControlName).disable();
        this.detailsForm.get(this.numberOfPostersControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    getPersonResponsibleByApplicantId(personResponsibleId) {
        const params = {
            $expand: "groups",
            $filter: `id eq ${personResponsibleId} and deleted eq false`
        };
        this.recipientService.getRecipientsObservable(params).pipe(take(1)).subscribe({
            next: (recipients) => {
                if (recipients.length > 0) {
                    const savedPersonResponsible = recipients[0];
                    this.detailsForm.get(this.personResponsibleFormControlName).setValue(savedPersonResponsible);
                    this.detailsForm.get(this.personResponsibleFormControlName).disable();
                }
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("person responsible", error, CRUDOperation.Get);
            }
        });
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: ChangeDetectorRef },
        { type: RecipientService },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsAComponent = __decorate([
    Component({
        selector: "app-view-application-details-a",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsAComponent);
export { ViewApplicationDetailsAComponent };
